import type { ImageData } from '@beat-venues/common-types';
import { ContentfulContentImage } from '@beat-venues/contentful-image';
import { type VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { ButtonOrLink } from '../button-or-link';
import { useTranslation } from 'react-i18next';

export interface PartnerProps
    extends CommonProps,
        VariantProps<typeof PartnerStyles> {
    image: ImageData;
    href?: string;
}

export const PartnerStyles = cva(
    'h-14 brightness-90 hover:brightness-100 flex items-center'
);

export const Partner = ({
    className,
    href,
    image,
    testId = 'partner',
    ...props
}: PartnerProps): JSX.Element => {
    const width = image.fields.image?.fields?.file?.details.image?.width;
    const { t } = useTranslation();

    let sizes;
    if (width) {
        sizes =
            `(max-width: 480px) ${width * 8}px, ` +
            `(max-width: 768px) ${width * 8}px, ` +
            `(max-width: 1024px) ${width * 8}px, ` +
            `(max-width: 1280px) ${width * 8}px, ` +
            `${width * 8}px`;
    }

    return (
        <li
            className={twMerge(PartnerStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            <ButtonOrLink className="focus" href={href}>
                <ContentfulContentImage
                    className="max-h-[65px] max-w-[200px]"
                    data={image}
                    rounded="none"
                    sizes={sizes}
                />
                <span className="sr-only">
                    {t('goToWebsite', { brand: image.fields.altText })}
                </span>
            </ButtonOrLink>
        </li>
    );
};
